import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { queryClient } from "./lib/query-client";
import { parseSearch, stringifySearch } from "./lib/search-params";
import "./styles/globals.css";

/*
 * Kompositionswurzel. Reihenfolge der Provider ist bedeutsam: der
 * QueryClientProvider liegt AUSSEN, damit Route-Komponenten (und später
 * Router-Loader) auf denselben Cache greifen wie die Komponenten darunter.
 */

const router = createRouter({
  routeTree,
  defaultPreload: "intent",

  // EIGENER Serialisierer, nicht der Default. Der würde Arrays JSON-kodieren
  // (`?loc=["A","B"]` statt `?loc=A&loc=B`) und Werte JSON-parsen (`q=123`
  // würde zur Zahl). Beides bricht die URL-Kompatibilität zum Altsystem, das
  // bis zum Cutover produktiv bleibt und dieselben Links lesen muss.
  // Begründung und Golden-Master-Abgleich: lib/search-params.ts.
  stringifySearch,
  parseSearch,
});

// Typsicherheit für `Link`-Ziele und `useSearch()` in der ganzen App.
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById("root");
if (!container) {
  throw new Error('index.html: Element mit id="root" fehlt.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
